import { Banner } from "@/components/flexkit/Banner";
import { isNoSuitableRunnerFoundError } from "@/routes/environments/create/create-environment-utils";
import { formatError, formatPolicyError } from "@/utils/errors";
import { ConnectError } from "@connectrpc/connect";
import { memo, type FC } from "react";

export const EnvironmentCreateError: FC<{ error: Error }> = memo(({ error }) => {
    let errorMessage: string;
    if (error instanceof ConnectError) {
        // Check for policy-specific errors first
        const policyMessage = formatPolicyError(error);
        if (policyMessage) {
            errorMessage = policyMessage;
        } else if (isNoSuitableRunnerFoundError(error)) {
            errorMessage = "No available runner found";
        } else {
            errorMessage = error.rawMessage;
        }
    } else {
        errorMessage = formatError(error);
    }

    return (
        <Banner
            variant="danger"
            text={<span className="first-letter:capitalize">{errorMessage}</span>}
            className="w-full text-sm"
            data-testid="environment-create-error"
        />
    );
});
EnvironmentCreateError.displayName = "EnvironmentCreateError";
